import { graphql, useStaticQuery } from 'gatsby';

export interface IDemoFormSettings {
  redirectUrl?: string;
}

interface ISitewideSettingsFormDemo {
  default: IDemoFormSettings;
  kpe: IDemoFormSettings;
}

const useDemoFormSettings = () => {
  const {
    wp: {
      sitewideSettings: {
        optionsSitewideSettings: {
          forms: {
            demo,
          },
        },
      },
    },
  }: {
    wp: {
      sitewideSettings: {
        optionsSitewideSettings: {
          forms: {
            demo: ISitewideSettingsFormDemo;
          };
        };
      };
    };
  } = useStaticQuery(graphql`
    query DemoFormSettings {
      wp {
        sitewideSettings {
          optionsSitewideSettings {
            forms {
              demo {
                default {
                  redirectUrl
                }
                kpe {
                  redirectUrl
                }
              }
            }
          }
        }
      }
    }
  `);

  return demo;
};

export default useDemoFormSettings;
